import { GiftIcon as PhosphorGiftIcon } from "@phosphor-icons/react/dist/ssr/Gift";

import { createAppIcon } from "@/components/createAppIcon";

export const GiftIcon = /* @__PURE__ */ createAppIcon(PhosphorGiftIcon);
